<template>
  <div class="flex flex-col space-y-20">
    <scorecard-group-tile
      v-for="scorecardGroup in data"
      :key="scorecardGroup.id"
      :scorecard-group="scorecardGroup"
      :select="select"
      :selected-ids="selectedIds"
      @tile-select="handleTileSelect"
    />
  </div>
</template>

<script setup lang="ts">
import ScorecardGroupTile from "./ScorecardGroupTile.vue";

import type { IScorecardGroup } from "@/models/scorecards";
import type { PropType } from "vue";

const emit = defineEmits<{
  (eventName: "update:selectedIds", newSelectedIds: string[]): void;
}>();

const props = defineProps({
  data: {
    type: Array as PropType<IScorecardGroup[]>,
    required: true,
  },
  select: {
    type: Boolean,
    default: false,
  },
  selectedIds: {
    type: Array as PropType<string[]>,
    default: () => [],
  },
});

const handleTileSelect = (id: string) => {
  const selected = [...props.selectedIds];
  if (selected.includes(id)) {
    selected.splice(selected.indexOf(id), 1);
  } else {
    selected.push(id);
  }
  emit("update:selectedIds", selected);
};
</script>
